var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.62,
    y: 363.65,
    width: 117.98,
    height: 84.15,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.82,
    y: 362.45,
    width: 123.59,
    height: 31.51,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.67,253.43s-21,1.86-24.94,4.23-12.93,3.26-12.93,3.26,4,11.27,0,23.05l3.69,3.22s6.86-.65,8.44,0,17.9,5.39,17.9,5.39",
    style: {
      fill: "#009CE1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.91,331s6.89,18.65,3.06,30.46S374.73,382,368.64,382s-54.79-12.18-54.79-12.18l-2.44,2.67-7.5-3.05,11.81,54.44s5.71,3.05,0,4.95-27.41,1.91-27.79,0a19.8,19.8,0,0,1,0-4.95l-3.22-6.09s.59-10.66,0-12.18S259.76,353.43,270,341.25s71-2.29,71-2.29l7.75-8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.56,283.38c9.31,16.13,33.24,41.29,33.24,41.29s-1.5,2.28,1.82,6.47A6.43,6.43,0,0,0,340.8,335c-.2,2.28,19.48,13.7,38.14,10.66s26.65-8.38,27-12.19-18.88-54.7-31.82-70.31a61.31,61.31,0,0,0-35.26-11.35c-14.94-.08-26.59,4.85-31.88,12.18",
    style: {
      fill: "#009CE1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.63,366.38c-1.52,7.23-7.23,17.35-9.51,21.54s-11.81,37.33-11.81,37.33.38,6.09-8.37,7.61S329.59,428.68,334,426s9.17-33.37,9.17-33.37-2.33-4.18,1.93-10.35S349.71,341,358,338.58c14.47-4.18,31.37,4.83,31.37,4.83s4.78,1.5,6.36,5.85",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.43,174H181.57l.85-18a3.28,3.28,0,0,1,3.27-3.12h9.62a3.28,3.28,0,0,1,3.27,3.12Z",
    style: {
      fill: "#009CE1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.28,447.32s-89.4-122.39-34-216.46,165.43-29.51,186.38-117.3,97.42-102.18,169.94,7.6,55.17,262.45,16.77,326.16Z",
    style: {
      fill: "#009CE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.89,447.32s-89.41-122.39-34-216.46,165.43-29.51,186.37-117.3,97.42-102.18,169.94,7.6S464.36,383.61,426,447.32Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-32"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 32.01,
    y1: 447.8,
    x2: 467.97,
    y2: 447.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.9,105.9a45.7,45.7,0,0,1,34.31,82.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,113.86a45.68,45.68,0,0,1,14-6.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.43,190.9a45.68,45.68,0,0,1-10.42-72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "361.24 205.32 358.51 207.73 362.76 193.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.23,196a45.37,45.37,0,0,1-20.18-1.09l-8.61,7.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.71,192.89a45.71,45.71,0,0,1-5.23,1.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.67,128.72a23,23,0,1,1-8.14.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.54,176.5a25.48,25.48,0,0,1-20.84-29.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.78,160a25.5,25.5,0,0,1-20.29,16.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.66,140.76a25.48,25.48,0,0,1,48.27,14.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.1,
    y1: 142.21,
    x2: 401.4,
    y2: 141.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.02,
    y1: 146.61,
    x2: 399.06,
    y2: 144.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "372.12 149.83 381.93 162.87 395.24 148.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.62,
    y: 363.65,
    width: 117.98,
    height: 84.15,
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "299.62 447.81 360.76 447.81 360.76 399.75 417.61 397.29 417.61 394.23 299.62 394.23 299.62 447.81",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 299.62,
    y: 363.65,
    width: 117.98,
    height: 84.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.82,
    y: 362.45,
    width: 123.59,
    height: 31.51,
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.82,
    y: 362.45,
    width: 65.52,
    height: 31.51,
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 296.82,
    y: 362.45,
    width: 123.59,
    height: 31.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,385.77v4.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,377.05v4.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,362.45v11.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.76,
    y1: 442.38,
    x2: 360.76,
    y2: 444.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.76,
    y1: 415.48,
    x2: 360.76,
    y2: 438.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.76,
    y1: 394.22,
    x2: 360.76,
    y2: 407.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.74,
    y: 387.26,
    width: 5.93,
    height: 15.7,
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,257c-6.3,2.62-34.25,5.67-34.25,5.67a157.07,157.07,0,0,1,16.08-27.47l-8.23-5.5s-21.74,23.39-27.09,39.87c0,0-1.6,7.45-.54,8.51s10,4.36,26.89,5.61,29,1.56,29,1.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.8,234.56s6.43,6.22,11.57,5.9l4-6.29s12.83-6.39,11.36-9.59-2.78-1-2.78-1l5.68-3.83s-7.11-4.23-8.62-4.22-5.37-.72-7.94.34-7.26,12.38-7.26,12.38Z",
    style: {
      fill: "#009CE1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,232.14s2.76-1.08,3.66-3,0-5.54,0-5.54",
    style: {
      fill: "#009CE1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.51,221.37a3.74,3.74,0,0,0,5,1.06",
    style: {
      fill: "#009CE1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.59,219.73a57.54,57.54,0,0,1,5.32,3.83",
    style: {
      fill: "#009CE1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.37,221.9l-4.18-3.46",
    style: {
      fill: "#009CE1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.73,262.67a25,25,0,0,1-3.35,11.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.67,253.43s-21,1.86-24.94,4.23-12.93,3.26-12.93,3.26,4,11.27,0,23.05l3.69,3.22s6.86-.65,8.44,0,17.9,5.39,17.9,5.39",
    style: {
      fill: "#009CE1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.16,290.63c-4.7-1.39-10.33-3.07-11.23-3.44-1.58-.65-8.44,0-8.44,0l-2.07-1.81c3-4.42,4.79-10,6-10,.65,0,2.06,1.81,3.38,3.86-1-6.35,1.25-14.73,2.37-7.6C303,276.88,308,284.83,312.16,290.63Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.67,253.43s-21,1.86-24.94,4.23-12.93,3.26-12.93,3.26,4,11.27,0,23.05l3.69,3.22s6.86-.65,8.44,0,17.9,5.39,17.9,5.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.46,416.45s7.8,22.68,7.46,29.8c0,0-12.7,3.17-19.18,2.38s-19.4.25-26.26.12-7.65-1.71-7.65-1.71-.53-2.9,4-5.53,22.68-4,24.26-17.16S310.46,416.45,310.46,416.45Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.91,331s6.89,18.65,3.06,30.46S374.73,382,368.64,382s-54.79-12.18-54.79-12.18l-2.44,2.67-7.5-3.05,11.81,54.44s5.71,3.05,0,4.95-27.41,1.91-27.79,0a19.8,19.8,0,0,1,0-4.95l-3.22-6.09s.59-10.66,0-12.18S259.76,353.43,270,341.25s71-2.29,71-2.29l7.75-8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.41,370l6,2.44,2.44-2.67S362.55,382,368.64,382s33.51-8.75,37.33-20.56a21.06,21.06,0,0,0,.69-2.79c-4.19,4.14-12.31,11.24-20.84,13.68,0,0,2.49-2.61-4.13-4s-26.93-33.59-26.93-33.59l-8.9-.7L341,339s-9.37-1.53-21.37-2.64A321,321,0,0,1,305.41,370Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.71,405.59c.59,1.52,0,12.18,0,12.18l3.22,6.09a19.8,19.8,0,0,0,0,4.95c.38,1.9,22.08,1.9,27.79,0s0-4.95,0-4.95l-11.27-51.93c-6,11.79-13.3,23.44-21.15,30.54C284.11,404.27,284.63,405.38,284.71,405.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.91,369.42s3.45-6.23,1.53-10.72",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.35,360a35.2,35.2,0,0,1,.25,5.53",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.78,352.82a36,36,0,0,1,1.06,4.05",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.89,378.11s-.32,18.14-10.18,27.48",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.41,412.87c-2.67,4-5.94,8.9-10.48,11",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.7,407.42c-.51.94-1.05,1.86-1.6,2.78",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.84,341.61A81,81,0,0,0,402.91,331h-2.37l-11.19,6.5S387.32,342.37,405.84,341.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.85,344.91s-5.8-2.61-11.5-1.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.91,331s6.89,18.65,3.06,30.46S374.73,382,368.64,382s-54.79-12.18-54.79-12.18l-2.44,2.67-7.5-3.05,11.81,54.44s5.71,3.05,0,4.95-27.41,1.91-27.79,0a19.8,19.8,0,0,1,0-4.95l-3.22-6.09s.59-10.66,0-12.18S259.76,353.43,270,341.25s71-2.29,71-2.29l7.75-8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.19,428.34s1.06,6.56,0,7.75S355,451.26,355,451.26s-27.6,4.29-35.82,3.7c-11-.79-13.57-4-13.57-4s-.19-4.22,10.16-7.53c12.77-4.08,22.61-17.72,22.61-17.72Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.56,283.38c9.31,16.13,33.24,41.29,33.24,41.29s-1.5,2.28,1.82,6.47A6.43,6.43,0,0,0,340.8,335c-.2,2.28,19.48,13.7,38.14,10.66s26.65-8.38,27-12.19-18.88-54.7-31.82-70.31a61.31,61.31,0,0,0-35.26-11.35c-14.94-.08-26.59,4.85-31.88,12.18",
    style: {
      fill: "#009CE1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.18,345c-1,.2-2.12.4-3.24.58-18.66,3-38.34-8.38-38.14-10.66a6.43,6.43,0,0,1,1.82-3.81c-.12-.16-.24-.31-.34-.46,9.11-1.76,17.45-6.65,13.62-6.48-5.25.24-8.47-.54-2.74-3.95s4.29-23.7,4.29-23.7,11.62-9,23.76,14.59C392.67,333.38,387.65,338.93,382.18,345Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.56,283.38c9.31,16.13,33.24,41.29,33.24,41.29s-1.5,2.28,1.82,6.47A6.43,6.43,0,0,0,340.8,335c-.2,2.28,19.48,13.7,38.14,10.66s26.65-8.38,27-12.19-18.88-54.7-31.82-70.31a61.31,61.31,0,0,0-35.26-11.35c-14.94-.08-26.59,4.85-31.88,12.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.16,254.78s-7.19-11.05-14.91-9.6-29.5-22.49-31.56-25.45-4.83,3.83-4.83,3.83-3.37,2.65-4.16,5.54,1.39,16.93,0,19.9a16.91,16.91,0,0,0-1.18,6.87l5.73-4.12s4.21,10.11,7.25,13.27,10.63-4.86,16.43-9.15,14.1-6.29,18.65,1.13",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.25,251.75l3-.77s-3.56-13.95-3-15.78,2.94-11.47,3-13.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.12,258.11c1.8,2,7.26-2.24,9-3.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.74,249.85a38.19,38.19,0,0,0,1.48,4.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.39,252.71c2.05.4,3.81,2.47,5,4.29A21.36,21.36,0,0,1,321,260s-3,9.89,6.91,8,13.14-12,13.14-12c-5.91-4.38-5.34-10.23-5.34-10.23-6.32-2.21-18.37,3-21.24,5.63C313.71,252,313.6,252.56,314.39,252.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.39,252.71c2.05.4,3.81,2.47,5,4.29,4.22-3.23,4.44-7.15,4.44-7.15l-9.34,1.49C313.71,252,313.6,252.56,314.39,252.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.58,324s18.06-1.3,22.64-11.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.37,334.82c-13.8,1.43-28.43,1.05-41.55-3.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.55,333.32c-2.19.45-4.4.79-6.62,1.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.82,246.65s4.5-5.58,5.74-9.5c5.31-16.8,6.24-27.58-12.8-31.71-13.45-2.91-20.36,15.12-20.05,21.64.18,3.68-1.63,7.27-2.54,10.19-1,3.26.92,16,5.09,17.09,5.33,1.33,14.13-.51,15.51-3.46",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.87,231.84c-.24.88.05,1.73.66,1.9s1.3-.41,1.54-1.29-.05-1.73-.66-1.9S318.11,231,317.87,231.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.67,228.79c-.24.88.05,1.73.66,1.9s1.3-.41,1.54-1.29-.05-1.73-.66-1.89S308.91,227.91,308.67,228.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,231.07s-4.76,4.19-5,5,2.67,3.11,2.67,3.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,242.43a10.57,10.57,0,0,0,7.74.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.83,223.75s2.14-1.06,5,1.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,222.43s-2.61-2.38-3.4,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.91,218.47s2.38,4.22,2,8.44a44.4,44.4,0,0,1-2,9l1,.79s4.05-2.11,5.1,0-2.91,7.65-2.91,7.65,2.31,5,5.78,5.53c0,0-.2-1.84,1-2.37s5.59-4.31,5.59-8.28c0,0,.92,1.24,0,4,0,0,7-14.15.41-24.7S327.91,218.47,327.91,218.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.14,237.1s5.06-4.27,5.71,0-6.47,10.28-8.18,8.19,0-2.48,0-2.48",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,252.46s3.1-.4,4.84,1-.31,3.52-3.27,1.8S307,252.46,307,252.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.45,253.43s15.13.11,24.33-33.7h1.56s-.52,28.57-24.88,35.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.91,210.86s-5,2.12-4.68,3.18,8.63,6.86,25.38,7c12.4.1,18.72,11,18.72,11,1.19-3.37-1.07-7.52-1.07-7.52s1.6-11.28-4.07-16.16c0,0-1.21-4.86-8.83-7.91-10.23-4.09-13.32,1.59-13.32,1.59A13.59,13.59,0,0,0,309.91,210.86Z",
    style: {
      fill: "#009CE1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.44,216.87c6.09.55,12.15,2.46,15.82,7.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.27,216.56c1.92,0,3.84,0,5.76.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.91,210.86c1.19,5,5.58,5.48,9.92,5.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.34,204.62a12.4,12.4,0,0,1,9.85,3.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,202.05c-5.23,8,5.34,4.08,9.2,3.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.91,229.52c0,.48-1.11,1.85-.34,2.53s1.38-1.45.85-3.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,223.23c0,.48-1.53,2.73-.76,3.4s1.36-.87,1-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.67,296.83s-23.22-5.46-22,2.79,6.73,24.88,6.73,24.88S332.73,343.28,331,344.67c-.54.43,6.37,7.11,6.37,7.11,5.61-3.17,44.9-12.69,46.42-19.54S378.67,296.83,378.67,296.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.36,260.92s10.66,9.9,10.28,17.13,4.57,20.89,4.57,20.89l-2.29,2.33s-15.23.76-22.46,5c0,0-3.18,2-2.28-5.33a14.89,14.89,0,0,0-4.83-10.4c-2.67-2.37-2.41-15.87-2.41-15.87",
    style: {
      fill: "#009CE1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.63,366.38c-1.52,7.23-7.23,17.35-9.51,21.54s-11.81,37.33-11.81,37.33.38,6.09-8.37,7.61S329.59,428.68,334,426s9.17-33.37,9.17-33.37-2.33-4.18,1.93-10.35S349.71,341,358,338.58c14.47-4.18,31.37,4.83,31.37,4.83s4.78,1.5,6.36,5.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.43,351.33c-2.62-5.38-7-10.19-13.07-11.36",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,358.56a30.83,30.83,0,0,0-1.25-4.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.62,392.7a12,12,0,0,1-3.44-.06",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.68,374.88c-5.72,6.89-13.2,14.25-21.87,17.09",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.63,366.38c-1.52,7.23-7.23,17.35-9.51,21.54s-11.81,37.33-11.81,37.33.38,6.09-8.37,7.61S329.59,428.68,334,426s9.17-33.37,9.17-33.37-2.33-4.18,1.93-10.35S349.71,341,358,338.58c14.47-4.18,31.37,4.83,31.37,4.83s4.78,1.5,6.36,5.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.57,366.93a1.48,1.48,0,0,1,1.75-1.15l4.74,1a5.5,5.5,0,0,0-10.14-2.6l-35.42-7.3a5.5,5.5,0,0,0-10.34-1.63l4.74,1a1.48,1.48,0,1,1-.6,2.9l-4.74-1a5.5,5.5,0,0,0,10.14,2.6L341.12,368a5.5,5.5,0,0,0,10.34,1.62l-4.74-1A1.49,1.49,0,0,1,345.57,366.93Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.75,338a44.65,44.65,0,0,0-8.24,6.46c-1.89,1.49-12.6,10.43-12.46,11.78s-.81,10.39,0,11.21,4.2-1.86,4.2-1.86.95,2.44,2,2.58a17,17,0,0,0,3.12-.14s1.76,2.71,3.38,2.44,3.8-3.39,2.21-3.52a2.28,2.28,0,0,0-2.21.94v-3.38a30.11,30.11,0,0,0,3.8-3.39c1.76-1.9,2.74-8.09,2.74-8.09.73-.41,5.61-2.67,7.26-3.26Z",
    style: {
      fill: "#009CE1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.25,
    y1: 365.6,
    x2: 320.6,
    y2: 359.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.4,
    y1: 368.04,
    x2: 325.95,
    y2: 364.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.42,
    y1: 362.45,
    x2: 320.04,
    y2: 364.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.39,368c-1.41-1-2.4-5.59-2.4-5.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.35,245.72s10.32,3.35,10.28,12.3c0,3.93-11,28.81-9.05,40.92s2.19,13.34,2.19,13.34-4.72.19-6.42,0-1.09,3-1.09,3l-6,1.14s-1.79-19.84-2-28.45,9.81-35.36,9.81-35.36a4.75,4.75,0,0,0-1.87-4.38",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.61,292.58c-.65,6-1.09,12-1.36,18.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.45,279.35c-.53,3.1-1,6.21-1.38,9.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.82,259.64q-2.16,7.78-3.65,15.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.77,249.85c.88,2.06.08,4.41-.29,6.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.87,273.35a34,34,0,0,0,3.75,9.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,262.21c.12,1.72.34,3.43.6,5.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.28,286.72a12.67,12.67,0,0,1-5.83,3.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.68,273a38.44,38.44,0,0,1-5.8,10.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Machine--inject-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "232.64 227.28 232.64 152.81 226.31 157.81 226.31 227.28 232.64 227.28",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.43,174H181.57l.85-18a3.28,3.28,0,0,1,3.27-3.12h9.62a3.28,3.28,0,0,1,3.27,3.12Z",
    style: {
      fill: "#009CE1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.52,160a5.29,5.29,0,1,1-5.29-5.28A5.29,5.29,0,0,1,198.52,160Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.68,160a4.45,4.45,0,1,1-4.45-4.45A4.45,4.45,0,0,1,197.68,160Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.64,
    cy: 160.45,
    r: 2.39,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.64,
    cy: 160.45,
    r: 1.37,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.13,168a4.58,4.58,0,1,1-4.58-4.58A4.59,4.59,0,0,1,193.13,168Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,168a3.52,3.52,0,1,1-3.52-3.52A3.52,3.52,0,0,1,192.07,168Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.43,174H181.57l.85-18a3.28,3.28,0,0,1,3.27-3.12h9.62a3.28,3.28,0,0,1,3.27,3.12Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.42 181.75 173.58 181.75 177.58 172.63 203.42 172.63 207.42 181.75",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.64,312.81v83.93a9.11,9.11,0,0,1-9.11,9.11H207.8v-7h14.55a4,4,0,0,0,4-4V312.81Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.42,224.68V165.19a6.45,6.45,0,0,1,6.45-6.45H85v5H80.71a2.8,2.8,0,0,0-2.81,2.8v57.72Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.14,
    y: 167.14,
    width: 3.96,
    height: 16.02,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.14,
    y: 167.14,
    width: 3.96,
    height: 16.02,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.09,
    y: 129.52,
    width: 54.07,
    height: 40.61,
    rx: 3.69,
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 135.18,
    width: 44.04,
    height: 29.27,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.42,258.74v39.48a6.46,6.46,0,0,0,6.45,6.46H85v-5H80.71a2.81,2.81,0,0,1-2.81-2.81V259.16Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.11,215.35H85a0,0,0,0,1,0,0v54.78a0,0,0,0,1,0,0H71.11a4,4,0,0,1-4-4V219.37A4,4,0,0,1,71.11,215.35Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.82,
    y: 180.75,
    width: 137.42,
    height: 256.97,
    rx: 3.96,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.6,
    y: 251.11,
    width: 231.85,
    height: 116.24,
    transform: "translate(458.76 159.7) rotate(90)",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.41,
    y: 196.31,
    width: 110.24,
    height: 225.85,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.09,392.22h-3.43V342.5a1.72,1.72,0,0,1,1.71-1.72h0a1.72,1.72,0,0,1,1.72,1.72Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.35,392.22h-3.43V342.5a1.72,1.72,0,0,1,1.71-1.72h0a1.72,1.72,0,0,1,1.72,1.72Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.61,392.22h-3.43V342.5a1.72,1.72,0,0,1,1.71-1.72h0a1.72,1.72,0,0,1,1.72,1.72Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.87,392.22h-3.43V342.5a1.72,1.72,0,0,1,1.71-1.72h0a1.72,1.72,0,0,1,1.72,1.72Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.13,392.22H168.7V342.5a1.72,1.72,0,0,1,1.71-1.72h0a1.72,1.72,0,0,1,1.72,1.72Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.39,392.22H175V342.5a1.72,1.72,0,0,1,1.71-1.72h0a1.72,1.72,0,0,1,1.72,1.72Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.88,330.9h34.55a5.8,5.8,0,0,1,5.8,5.8v55.52a0,0,0,0,1,0,0H99.88a0,0,0,0,1,0,0V330.9A0,0,0,0,1,99.88,330.9Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.88,
    y: 343.68,
    width: 30.99,
    height: 15.3,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.25,
    y1: 347.97,
    x2: 126.25,
    y2: 354.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.22,
    y1: 347.97,
    x2: 123.22,
    y2: 354.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.19,
    y1: 347.97,
    x2: 120.19,
    y2: 354.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.15,
    y1: 347.97,
    x2: 117.15,
    y2: 354.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.12,
    y1: 347.97,
    x2: 114.12,
    y2: 354.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5,378.71h-9a1,1,0,0,1,0-2h9c6.47,0,9-5.91,11.63-12.18,2.09-4.95,4.26-10.07,8.61-12.12a16.21,16.21,0,0,1,15.42.55,11.52,11.52,0,0,1,5.52,9.85,1,1,0,0,1-2,0,9.43,9.43,0,0,0-4.59-8.16,14.2,14.2,0,0,0-13.5-.43C154.93,356,153,360.5,151,365.31,148.18,371.9,145.29,378.71,137.5,378.71Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.17,
    y: 359.5,
    width: 42.33,
    height: 30.67,
    rx: 8.19,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.17,361.67h20.09a12.44,12.44,0,0,1,12.44,12.44v12.45a3.6,3.6,0,0,1-3.6,3.6H102.17a3.6,3.6,0,0,1-3.6-3.6V365.28A3.6,3.6,0,0,1,102.17,361.67Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.66,
    y: 335.65,
    width: 19.85,
    height: 19.85,
    rx: 2.11,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,345.57a4.39,4.39,0,1,1-4.39-4.38A4.39,4.39,0,0,1,194,345.57Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.19,
    y: 373.76,
    width: 6.07,
    height: 18.46,
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.09,368.22h11.47a2.41,2.41,0,0,1,2.41,2.41v21.59a0,0,0,0,1,0,0H177.68a0,0,0,0,1,0,0V370.63A2.41,2.41,0,0,1,180.09,368.22Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.31 365.16 102.77 365.16 102 366.5 102.77 367.84 104.31 367.84 105.09 366.5 104.31 365.16",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.31 383.42 102.77 383.42 102 384.76 102.77 386.1 104.31 386.1 105.09 384.76 104.31 383.42",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.36 344.23 188.81 344.23 188.04 345.57 188.81 346.91 190.36 346.91 191.13 345.57 190.36 344.23",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.31 333.78 102.77 333.78 102 335.12 102.77 336.46 104.31 336.46 105.09 335.12 104.31 333.78",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.47 333.78 133.92 333.78 133.15 335.12 133.92 336.46 135.47 336.46 136.24 335.12 135.47 333.78",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 394.91,
    width: 100.59,
    height: 22.68,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.15,
    y: 397.81,
    width: 32.75,
    height: 16.35,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.47 400.52 167.93 400.52 167.16 401.85 167.93 403.19 169.47 403.19 170.25 401.85 169.47 400.52",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.47 408.72 167.93 408.72 167.16 410.06 167.93 411.4 169.47 411.4 170.25 410.06 169.47 408.72",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.47 400.52 191.93 400.52 191.16 401.85 191.93 403.19 193.47 403.19 194.25 401.85 193.47 400.52",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.47 408.72 191.93 408.72 191.16 410.06 191.93 411.4 193.47 411.4 194.25 410.06 193.47 408.72",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.09,
    y: 409.87,
    width: 3.85,
    height: 3.85,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.39,
    y: 409.87,
    width: 3.85,
    height: 3.85,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.7,
    y: 409.87,
    width: 3.85,
    height: 3.85,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.86,411.79a1.93,1.93,0,1,1-1.93-1.92A1.92,1.92,0,0,1,130.86,411.79Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.16,411.79a1.93,1.93,0,1,1-1.92-1.92A1.92,1.92,0,0,1,138.16,411.79Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,320.72c32.88,0,67-27.53,97-27.53",
    style: {
      fill: "none",
      stroke: "#999",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,210.6c18.64,0,56.41,41.3,97,41.3",
    style: {
      fill: "none",
      stroke: "#009CE1",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,210.6c-22.19,0-63.95,68.83-97,68.83",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,293.19c21.36,0,73.64-55.35,96-55.06",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,251.9c37.63,0,69.34,68.82,97,68.82",
    style: {
      fill: "none",
      stroke: "#009CE1",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,307c14.68,0,67-27.53,97-27.53",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,307c-18.76,0-67.38-82.59-97-82.59",
    style: {
      fill: "none",
      stroke: "#bfbfbf",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,238.13c15.47,0,55.1-13.76,97-13.76",
    style: {
      fill: "none",
      stroke: "#009CE1",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,265.66c19.43,0,38.26,9,50.6,9s32.72-9,46.4-9",
    style: {
      fill: "none",
      stroke: "#999",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.9,
    y: 207.31,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.9,
    y: 221.07,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.9,
    y: 234.84,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.9,
    y: 248.6,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.9,
    y: 262.37,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.9,
    y: 276.13,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.9,
    y: 289.9,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.9,
    y: 303.66,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.9,
    y: 317.43,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 207.31,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 221.07,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 234.84,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 248.6,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 262.37,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 276.13,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 289.9,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 303.66,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 317.43,
    width: 2.25,
    height: 6.59,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.27,431.41H224.79a4.13,4.13,0,0,1,4.13,4.13v13.31a0,0,0,0,1,0,0H70.14a0,0,0,0,1,0,0V435.53A4.13,4.13,0,0,1,74.27,431.41Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.74,446.24H234.31a2.78,2.78,0,0,1,2.78,2.78v7.07a0,0,0,0,1,0,0H62a0,0,0,0,1,0,0V449A2.78,2.78,0,0,1,64.74,446.24Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,142.58h3.45c2.19,0,3.26,1.21,3.26,3.44v7c0,2.22-1.07,3.43-3.26,3.43H95Zm2.18,2v9.94h1.23c.7,0,1.12-.36,1.12-1.35v-7.23c0-1-.42-1.36-1.12-1.36Z",
    style: {
      fill: "#009CE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,145.92c0-2.23,1.17-3.5,3.32-3.5s3.32,1.27,3.32,3.5v7.23c0,2.22-1.18,3.49-3.32,3.49s-3.32-1.27-3.32-3.49Zm2.19,7.37c0,1,.43,1.37,1.13,1.37s1.13-.38,1.13-1.37v-7.51c0-1-.44-1.37-1.13-1.37s-1.13.37-1.13,1.37Z",
    style: {
      fill: "#009CE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,146.41h0v10.07h-2v-13.9h2.74l2.2,8.32h0v-8.32h2v13.9h-2.25Z",
    style: {
      fill: "#009CE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.67,148.44h3v2h-3v4.07h3.78v2h-6v-13.9h6v2h-3.78Z",
    style: {
      fill: "#009CE1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.88,
    y: 204.93,
    width: 13.19,
    height: 184.01,
    rx: 2.92,
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,208.42a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,225.15,208.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,216.32a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,225.15,216.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,224.22a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,225.15,224.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,232.12a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,225.15,232.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,240a1.22,1.22,0,0,0,0,2.43,1.22,1.22,0,1,0,0-2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,247.93a1.22,1.22,0,0,0,0,2.43,1.22,1.22,0,1,0,0-2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,255.83a1.22,1.22,0,0,0,0,2.43,1.22,1.22,0,1,0,0-2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,263.73a1.22,1.22,0,0,0,0,2.43,1.22,1.22,0,1,0,0-2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,271.63a1.22,1.22,0,1,0,1.22,1.21A1.21,1.21,0,0,0,225.15,271.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,279.53a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,225.15,279.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,287.43a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,225.15,287.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,295.33a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,225.15,295.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,303.23a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,225.15,303.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,311.14a1.22,1.22,0,0,0,0,2.43,1.22,1.22,0,1,0,0-2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,319a1.22,1.22,0,0,0,0,2.43,1.22,1.22,0,1,0,0-2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,326.94a1.22,1.22,0,0,0,0,2.43,1.22,1.22,0,1,0,0-2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,334.84a1.22,1.22,0,0,0,0,2.43,1.22,1.22,0,1,0,0-2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,342.74a1.22,1.22,0,1,0,1.22,1.21A1.21,1.21,0,0,0,225.15,342.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,350.64a1.22,1.22,0,1,0,1.22,1.22A1.21,1.21,0,0,0,225.15,350.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,358.54a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,225.15,358.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,366.44a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,225.15,366.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,374.34a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,225.15,374.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,382.25a1.21,1.21,0,1,0,1.22,1.21A1.21,1.21,0,0,0,225.15,382.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 213.59,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,220.27a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,229.47,220.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 229.39,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 237.29,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,244a1.22,1.22,0,1,0,1.22,1.21A1.21,1.21,0,0,0,229.47,244Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 253.09,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,259.78a1.22,1.22,0,1,0,1.22,1.21A1.21,1.21,0,0,0,229.47,259.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 268.89,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 276.8,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,283.48a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,229.47,283.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 292.6,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 300.5,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 308.4,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 316.3,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,323a1.22,1.22,0,1,0,1.22,1.21A1.21,1.21,0,0,0,229.47,323Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 332.1,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,338.79a1.22,1.22,0,1,0,1.22,1.21A1.21,1.21,0,0,0,229.47,338.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,346.69a1.22,1.22,0,1,0,1.22,1.22A1.21,1.21,0,0,0,229.47,346.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 355.81,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,362.49a1.22,1.22,0,1,0,1.22,1.22A1.22,1.22,0,0,0,229.47,362.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 371.61,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.47,
    cy: 379.51,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,210.85a1.22,1.22,0,1,0-1.22-1.21A1.21,1.21,0,0,0,233.8,210.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 217.54,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 225.44,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,232.12a1.22,1.22,0,1,0,1.21,1.22A1.22,1.22,0,0,0,233.8,232.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 241.24,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,247.93a1.22,1.22,0,1,0,1.21,1.21A1.21,1.21,0,0,0,233.8,247.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,255.83A1.22,1.22,0,1,0,235,257,1.21,1.21,0,0,0,233.8,255.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 264.94,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,271.63a1.22,1.22,0,1,0,1.21,1.21A1.21,1.21,0,0,0,233.8,271.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 280.75,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,287.43a1.22,1.22,0,1,0,1.21,1.22A1.22,1.22,0,0,0,233.8,287.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,295.33a1.22,1.22,0,1,0,1.21,1.22A1.22,1.22,0,0,0,233.8,295.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 304.45,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,311.14a1.22,1.22,0,1,0,1.21,1.21A1.21,1.21,0,0,0,233.8,311.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,319a1.22,1.22,0,1,0,1.21,1.21A1.21,1.21,0,0,0,233.8,319Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 328.15,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,334.84a1.22,1.22,0,1,0,1.21,1.21A1.21,1.21,0,0,0,233.8,334.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 343.95,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,350.64a1.22,1.22,0,1,0,1.21,1.22A1.21,1.21,0,0,0,233.8,350.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 359.76,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 367.66,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,374.34a1.22,1.22,0,1,0,1.21,1.22A1.22,1.22,0,0,0,233.8,374.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.8,
    cy: 383.46,
    r: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.45,121.46a4.48,4.48,0,0,0-2.92,7.9,4.48,4.48,0,0,0,2.92,7.9h.1a4.8,4.8,0,0,0,4.4,2.89,4.75,4.75,0,0,0,3.11-1.17h0a4.4,4.4,0,0,0,1.09.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.18,127.21a4.79,4.79,0,0,0-4.79-4.79,5,5,0,0,0-.54.06,4.49,4.49,0,0,0-8.41-.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68,137.54a4.75,4.75,0,0,0,2.53-7.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.06,125.34h0a6,6,0,0,0,1.29.16,5.71,5.71,0,0,0,4.19-1.86,5.65,5.65,0,0,0,3-8.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.64,117.94A5.36,5.36,0,0,0,246,123.3h.12a5.69,5.69,0,0,0,5.23,3.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.73,111.34a5.7,5.7,0,0,0-5.7-5.7c-.23,0-.44,0-.65.06a5.34,5.34,0,0,0-10-.63,5.28,5.28,0,0,0-2.37-.58,5.34,5.34,0,0,0-3.48,9.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3,97.26a6.81,6.81,0,0,0,11.2,4.87,7.14,7.14,0,0,0,.54-.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.63,81.85a6.75,6.75,0,0,0-2.41,4.93A6.81,6.81,0,0,0,210.6,95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.29,81.82a6.4,6.4,0,0,0-10.44-5.95l-.1.1a6.8,6.8,0,0,0-9.8,5v0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.63,102.56a6.32,6.32,0,0,0,5.06-1.41,6.41,6.41,0,0,0,2-6.71,6.33,6.33,0,0,0,2.62-1.3,6.41,6.41,0,0,0,.79-9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.d83dc46a2b2e04ad42d123d8990b4ba5.svg";
export { ForwardRef as ReactComponent };